/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { termsEditorViewEditor } from "../../terms/viewEditor";

export function registerMenus(dc: IEditor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.create", {
		id: "page",
		label: termsEditorViewEditor.mainMenu.sectionCreate.view.label,
		tooltip: termsEditorViewEditor.mainMenu.sectionCreate.view.tooltip,
		icon: "mdi/view-dashboard",
		flags: [ "primary" ],
		order: 10,
		commandId: "viewEditor.createPage.open"
	});
}
